export default __webpack_public_path__ + "static/logo-studnicky-white-6c3c45c0eb4f5a504363f3ebd92f1835.svg";